"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M9.955 2.3c2.142 0 3.947.74 5.431 2.225 1.485 1.485 2.226 3.29 2.226 5.433 0 .858-.13 1.654-.389 2.392a6.802 6.802 0 0 1-1.049 1.958l-.163.209 5.399 5.406c.195.199.294.44.294.747 0 .304-.1.543-.297.736l-.002.002a.996.996 0 0 1-.742.292.995.995 0 0 1-.742-.292l-5.393-5.393-.21.162a6.888 6.888 0 0 1-1.97 1.05 7.233 7.233 0 0 1-2.393.388c-2.143 0-3.948-.74-5.433-2.225-1.485-1.485-2.226-3.29-2.226-5.432 0-2.143.741-3.948 2.226-5.433C6.007 3.041 7.812 2.3 9.955 2.3Zm0 2.128c-1.534 0-2.847.538-3.92 1.611-1.072 1.073-1.61 2.385-1.61 3.919 0 1.534.538 2.846 1.61 3.919 1.073 1.072 2.386 1.611 3.92 1.611 1.533 0 2.846-.538 3.918-1.611 1.073-1.073 1.612-2.385 1.612-3.919 0-1.534-.539-2.846-1.611-3.919-1.073-1.073-2.386-1.611-3.92-1.611Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};